import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { DeliveryServicesContext } from './DeliveryServicesContext';
import { getVisibleCategories } from '../api/Products';
import { useRouter } from 'next/router';

const VisibleCategoriesContext = createContext(undefined);

export const VisibleCategoriesProvider = ({ children }) => {
  const { getCollectionTypes, selectedService, selectedShop } = useContext(DeliveryServicesContext);
  const router = useRouter();

  const {
    data: visibleCategories,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['visible-categories', selectedService, selectedShop, router.locale],
    queryFn: () => {
      const collections = getCollectionTypes();
      return getVisibleCategories(collections);
    },
    select: d => d.data,
    staleTime: 1000 * 60 * 60,
    enabled: process.env.hideEmptyCategories && Boolean(selectedService && selectedShop),
  });

  return (
    <VisibleCategoriesContext.Provider value={{ visibleCategories, isLoading, isError }}>
      {children}
    </VisibleCategoriesContext.Provider>
  );
};

export const useVisibleCategories = () => {
  const context = useContext(VisibleCategoriesContext);
  if (context === undefined) {
    throw new Error('useVisibleCategories must be used within a VisibleCategoriesProvider');
  }
  return context;
};
